import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import ContentToggle from '../../ContentToggle';
import LoadingMsgBar from '../../LoadingMsgBar';
import GlobalMessage from '../../GlobalMessage';
import ManageGroupsTable from '../../ManageGroupsTable';
import AuthenticationService from '../../../Services/AuthenticationService';
import axios from 'axios';
import { isEmpty } from '../../../utils/Utils';
import { config } from '../../../Services/ConfigService';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from '@material-ui/core/Grid';
import './ManageGroups.css';

const styles = theme => ({
    root: {
        width: '100%',
    },
    button: {
        margin: theme.spacing(1),
        cursor: 'pointer',
        color: '#0f197d'
    },
    input: {
        display: 'none',
    },
    searchGrid: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    searchItem: {
        flex: '1 1 auto',
        minWidth: '220px',
        maxWidth: '300px',
        margin: theme.spacing(0, 1),
    },
    fieldSeparator: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: theme.spacing(1),
        margin: theme.spacing(0, 1),
    },
});

window.analytics = { pageName: 'Manage Groups: List View' };

// Helper function for sorting
function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function descendingComparator(a, b, orderBy) {
    const valueA = a[orderBy] !== null ? String(a[orderBy]).toUpperCase() : '';
    const valueB = b[orderBy] !== null ? String(b[orderBy]).toUpperCase() : '';
    
    if (valueB < valueA) {
        return -1;
    }
    if (valueB > valueA) {
        return 1;
    }
    return 0;
}

class ManageGroups extends Component {
    constructor(props) {
        super(props);
        this.state = {
            groups: [],
            filteredGroups: [], 
            selected: [],
            //username: '',
            grpId: '',
            isMirror: true,
            errorMsg: '',
            successMessage: '',
            page: 0,
            rowsPerPage: 10,
            order: 'asc',
            orderBy: 'groupName',
            showAddGroup: false,
            isLoading: false,
            // New fields for search
            portalUserGroupId: '',
            taxIdNumber: '',
            rosterHubSource: '',
            selectedRosterHubSource: null,
            sourceNames: [], // Array for roster hub source names
            sourcesData: [], // Full data for roster sources
            providerHubGroupId: '',
            // More Options fields
            username: '',
            emailAddress: '',
            // UI state
            moreOptionsExpanded: false,
            fieldError: '',
            progMsg: '',
            showResults: false,
            searchInfo: null,
            searchPerformed: false
        };
    }

    componentDidMount() {
        this.getUser();
        
        // Check if we have search info from navigation state
        const hasSearchInfo = this.props.location && 
                              this.props.location.state && 
                              this.props.location.state.searchInfo;
        
        // Load roster sources (which will also set the selectedRosterHubSource if needed)
        this.loadRosterSources();
        
        // If we have search info, perform search and set form fields
        if(hasSearchInfo) {
            const searchInfo = this.props.location.state.searchInfo;
            
            // Perform search using the searchInfo
            this.searchGroups(true, searchInfo);
            
            // Set all form fields to match the search parameters
            this.setState({
                portalUserGroupId: searchInfo.portalUserGroupId || '',
                taxIdNumber: searchInfo.taxIdNumber || '',
                rosterHubSource: searchInfo.rosterHubSource || '',
                // Note: selectedRosterHubSource will be set in loadRosterSources after API call completes
                providerHubGroupId: searchInfo.providerHubGroupId || '',
                username: searchInfo.username || '',
                emailAddress: searchInfo.emailAddress || '',
                moreOptionsExpanded: !!(searchInfo.username || searchInfo.emailAddress),
                searchInfo: searchInfo
            });
            
            console.log('Restored search state from navigation:', searchInfo);
        }
    }

    getUser = () => {
        let currentUser = AuthenticationService.getMirrorUser();
        if(isEmpty(currentUser)) {
            currentUser = AuthenticationService.getLoggedInUserName();
            this.setState({isMirror: false});
        }
        
        this.setState({ username: currentUser });
        
        AuthenticationService.getUsrDtls(currentUser)
            .then((response) => {
                this.setState({grpId: response.data.grpInfoId});
                // this.loadGroupData();
            }).catch((error) => {
                console.log('Error retrieving user details:', error);
                this.setState({
                    errorMsg: 'Error: There was a problem retrieving user information. Please try again later.'
                });
            });
    }
    
    loadRosterSources = () => {
        // Set loading message
        this.setState({ progMsg: 'Loading roster sources...' });
        
        // Call the API to get roster sources
        AuthenticationService.getAllRosterSources()
            .then((response) => {
                // Process roster sources
                let sourceNames = [];
                let sourcesData = [];
                
                if (response.data && response.data.length > 0) {
                    sourcesData = response.data;
                    
                    // Extract source names for Autocomplete
                    sourceNames = Array.from(
                            new Set(
                                sourcesData
                                    .map(source => source.sourceName || '')
                                    .filter(Boolean)
                            )
                        ).sort((a, b) => a.localeCompare(b));
                    
                    // Check if we have a searchInfo from props and need to set the selectedRosterHubSource
                    let selectedRosterHubSource = this.state.selectedRosterHubSource;
                    
                    // If we have a rosterHubSource ID from a previous search, find the corresponding name
                    if (this.props.location && 
                        this.props.location.state && 
                        this.props.location.state.searchInfo && 
                        this.props.location.state.searchInfo.rosterHubSource) {
                        
                        const sourceId = this.props.location.state.searchInfo.rosterHubSource;
                        const sourceData = sourcesData.find(source => source.sourceId === sourceId);
                        
                        if (sourceData) {
                            selectedRosterHubSource = sourceData.sourceName;
                            console.log('Found roster source name for ID:', sourceId, 'Name:', selectedRosterHubSource);
                        }
                    }
                    
                    this.setState({ 
                        sourceNames: sourceNames,
                        sourcesData: sourcesData,
                        selectedRosterHubSource: selectedRosterHubSource,
                        progMsg: ''
                    });
                    
                    console.log('Loaded roster sources:', sourcesData.length);
                } else {
                    this.setState({ 
                        progMsg: '',
                        sourceNames: [],
                        sourcesData: []
                    });
                }
            })
            .catch((error) => {
                console.error('Error retrieving roster sources:', error);
                this.setState({ 
                    errorMsg: 'Error: Unable to retrieve roster sources. Please try again later.',
                    progMsg: ''
                });
            });
    }
    
    setErrorMsg = (message = 'Error: There was an error retrieving data. Please try again or contact Customer Service.') => {
        this.setState({ errorMsg: message });
    }
    
    handleAddGroup = () => {
        this.setState({ 
            showAddGroup: true,
            successMessage: '', // Clear any previous success messages
            errorMsg: ''        // Clear any previous error messages
        });
    }

    handleAddGroupCancel = () => {
        this.setState({ showAddGroup: false });
    }
    
    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage });
    };
    
    handleChangeRowsPerPage = (event) => {
        this.setState({ 
            rowsPerPage: parseInt(event.target.value, 10),
            page: 0 
        });
    }
    
    handleRequestSort = (event, property) => {
        const isAsc = this.state.orderBy === property && this.state.order === 'asc';
        this.setState({
            order: isAsc ? 'desc' : 'asc',
            orderBy: property
        });
    };
    
    handleFilter = (value, property) => {
        const filtered = this.state.groups.filter(item => {
            if (!value) return true;
            if (!item[property]) return false;
            return String(item[property]).toLowerCase().includes(value.toLowerCase());
        });
        
        this.setState({
            filteredGroups: filtered,
            page: 0
        });
    }
    
    onChange = event => {
        const { target: { name, value } } = event;
        this.setState({ [name]: value });
    }
    
    handleRosterHubSourceChange = (event, value) => {
        if (value) {
            // Find the source ID that corresponds to the selected source name
            const sourceData = this.state.sourcesData.find(source => source.sourceName === value);
            const sourceId = sourceData ? sourceData.sourceId : null;
            
            // When a source is selected, store it and clear other search fields
            this.setState({ 
                selectedRosterHubSource: value,
                rosterHubSource: sourceId, // Store the source ID, not the display name
                portalUserGroupId: '',
                taxIdNumber: '',
                providerHubGroupId: '',
                username: '',
                emailAddress: '',
                fieldError: ''
            });
        } else {
            this.setState({ 
                selectedRosterHubSource: null,
                rosterHubSource: ''
            });
        }
    }
    
    handleSearch = () => {
        // Reset error messages
        this.setState({
            fieldError: '',
            errorMsg: ''
        });
        
        // Check if at least one search field is filled
        if (this.state.portalUserGroupId === '' && 
            this.state.taxIdNumber === '' && 
            this.state.selectedRosterHubSource === null && 
            this.state.providerHubGroupId === '' &&
            this.state.username === '' &&
            this.state.emailAddress === '') {
                
            this.setState({
                fieldError: 'Error: Enter at least one search criteria',
                errorMsg: `An error has occurred. Please address all fields marked with "Error".`,
                showResults: false
            });
        } else {
            // Create search info with current state values
            const searchInfo = {
                portalUserGroupId: this.state.portalUserGroupId,
                taxIdNumber: this.state.taxIdNumber,
                rosterHubSource: this.state.rosterHubSource, // This should be the source ID now
                providerHubGroupId: this.state.providerHubGroupId,
                username: this.state.username,
                emailAddress: this.state.emailAddress
            };
            
            // Update state and initiate search
            this.setState({ 
                isLoading: true, 
                progMsg: 'Searching...',
                groups: [],
                filteredGroups: [],
                searchInfo: searchInfo,
                searchPerformed: true
            }, () => {
                // Execute search after state is updated
                this.searchGroups(true, searchInfo);
            });
        }
    }

    searchGroups = (resetErrorMsg, searchInfo) => {
        if (resetErrorMsg) {
            this.setState({ errorMsg: '' });
        }

        if(!searchInfo){
          searchInfo = {
            portalUserGroupId: this.state.portalUserGroupId,
            taxIdNumber: this.state.taxIdNumber,
            rosterHubSource: this.state.rosterHubSource,
            providerHubGroupId: this.state.providerHubGroupId,
            username: this.state.username,
            emailAddress: this.state.emailAddress
          };
        } 
        // No need to reset state values here - we'll use the searchInfo parameter directly
        this.setState({progMsg:`Please wait while we retrieve data.`,fieldError: '',fieldGidError:'',
            errorMsg: '',users: [],filteredUsers: [],successmessage: '', searchInfo: searchInfo,filtered:false } );
            
        // Debug logging to help diagnose search issues
        console.log('Searching groups with parameters:', {
            portalUserGroupId: searchInfo.portalUserGroupId,
            taxIdNumber: searchInfo.taxIdNumber,
            rosterHubSource: searchInfo.rosterHubSource,
            providerHubGroupId: searchInfo.providerHubGroupId, 
            username: searchInfo.username,
            emailAddress: searchInfo.emailAddress
        });

        AuthenticationService.searchGroup(searchInfo.portalUserGroupId, searchInfo.taxIdNumber, searchInfo.rosterHubSource, searchInfo.providerHubGroupId, searchInfo.username, searchInfo.emailAddress)
            .then(response => {
                if(response.status === 200 ) {
                    this.setState({users: response.data,filteredUsers: response.data , progMsg:'', isDownloadEnabled:true});
                    if(resetErrorMsg){
                        this.setState({ 
                            groups: response.data,
                            filteredGroups: response.data,
                            isLoading: false,
                            progMsg: '',
                            showResults: true,
                            //errorMsg: response.data.length === 0 ? 'No groups found matching the specified criteria. Please refine your search.' : '',
                            errorMsg: response.data.length === 0 ?
                            `There are no groups available for the criteria entered. Please revise your search criteria and try again or go to MANAGE GROUPS.` : ''}
                        );
                    }
                }
            }).catch((error) => {
                this.setState({ 
                    errorMsg: `Error: There was an error retrieving data. Please try again or contact Customer Service.`, 
                    progMsg: '',
                    isLoading: false
                });
                console.log(`Search For Group Error:`, error);
            })
    }

    handleSelectedAction = (groupInfoId, action) => {
        console.log(`Selected action for group ${groupInfoId}: ${action}`);
        const group = this.state.groups.find(group => group.groupInfoId === groupInfoId);

        if(action === 'Manage Roster Hub Sources'){
            this.props.history.push({
                pathname: '/wcpp/ManageRosterSourcesForUserGroup',
                state: {
                    groupInfo: group,
                    // Set the mode to 'existingGroup' when coming from UserSearch
                    mode: 'existingGroup',
                    searchInfo: this.state.searchInfo,
                    returnPath: '/wcpp/ManageGroups'
                }
            })
        }
    }

    handleReset = () => {
        this.setState({
            portalUserGroupId: '',
            taxIdNumber: '',
            rosterHubSource: '',
            selectedRosterHubSource: null,
            providerHubGroupId: '',
            username: '',
            emailAddress: '',
            fieldError: '',
            errorMsg: '',
            progMsg: '',
            showResults: false,
            searchPerformed: false,
            groups: [],
            filteredGroups: []
        });
    }
    
    handleMoreOptionsToggle = (expanded) => {
        this.setState({ moreOptionsExpanded: expanded });
        
        // If collapsing and there are values in the more options fields,
        // clear those fields to enable the top row search again
        if (!expanded && (this.state.username !== '' || this.state.emailAddress !== '')) {
            this.setState({
                username: '',
                emailAddress: ''
            });
        }
    }
    
    setFilter = (filtered) => {
        if (filtered && filtered.length >= 0) {
            this.setState({ filteredGroups: filtered });
        }
    }

    render() {
        const { classes } = this.props;
        
        if (this.state.isLoading) {
            return (
                <div className="loading-container">
                    <p>Loading group data...</p>
                </div>
            );
        }
        
        return (
            <div className="App-content Manage-users">
                <h1 className="App-page-label">Manage Portal User Groups</h1>
                
                <LoadingMsgBar loadMsg={this.state.progMsg}/>
                
                <GlobalMessage message={this.state.errorMsg}/>
                
                <GlobalMessage type='success' message={this.state.successMessage}/>
                

                
                <Grid container className={classes.searchGrid} spacing={2}>
                    <Grid item className={classes.searchItem}>
                        <Tooltip className='App-tool-tip' 
                                title={isEmpty(this.state.groups) ? 'Enter search criteria' : ''} 
                                disableHoverListener 
                                placement='bottom-start' 
                                aria-label="Enter search criteria">
                            <TextField
                                id="outlined-basic"
                                name='portalUserGroupId'
                                autoFocus
                                disabled={this.state.taxIdNumber !== '' || this.state.selectedRosterHubSource !== null || this.state.providerHubGroupId !== '' || 
                                        (this.state.moreOptionsExpanded && (this.state.username !== '' || this.state.emailAddress !== ''))}
                                fullWidth
                                error={this.state.fieldError !== ''}
                                helperText={this.state.fieldError}
                                inputProps={{maxLength: 14}}
                                defaultValue=" "
                                label="Portal User Group ID"
                                margin="normal"
                                variant="outlined"
                                onChange={this.onChange}
                                value={this.state.portalUserGroupId}
                            />
                        </Tooltip>
                    </Grid>
                    
                    <Grid item className={classes.fieldSeparator}>
                        OR
                    </Grid>

                    <Grid item className={classes.searchItem}>
                        <TextField
                            id="outlined-basic"
                            name='taxIdNumber'
                            disabled={this.state.portalUserGroupId !== '' || this.state.selectedRosterHubSource !== null || this.state.providerHubGroupId !== '' || 
                                    (this.state.moreOptionsExpanded && (this.state.username !== '' || this.state.emailAddress !== ''))}
                            fullWidth
                            inputProps={{maxLength: 9}}
                            defaultValue=" "
                            label="Tax ID Number (TIN)"
                            margin="normal"
                            variant="outlined"
                            onChange={this.onChange}
                            value={this.state.taxIdNumber}
                        />
                    </Grid>
                    
                    <Grid item className={classes.fieldSeparator}>
                        OR
                    </Grid>

                    <Grid item className={classes.searchItem}>
                        <Autocomplete
                            id="roster-hub-source-select"
                            options={this.state.sourceNames}
                            value={this.state.selectedRosterHubSource}
                            onChange={this.handleRosterHubSourceChange}
                            fullWidth
                            disabled={this.state.portalUserGroupId !== '' || this.state.taxIdNumber !== '' || this.state.providerHubGroupId !== '' || 
                                    (this.state.moreOptionsExpanded && (this.state.username !== '' || this.state.emailAddress !== ''))}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Roster Hub Source"
                                    variant="outlined"
                                    margin="normal"
                                />
                            )}
                        />
                    </Grid>
                    
                    <Grid item className={classes.fieldSeparator}>
                        OR
                    </Grid>

                    <Grid item className={classes.searchItem}>
                        <TextField
                            id="outlined-basic"
                            name='providerHubGroupId'
                            disabled={this.state.portalUserGroupId !== '' || this.state.taxIdNumber !== '' || this.state.selectedRosterHubSource !== null || 
                                    (this.state.moreOptionsExpanded && (this.state.username !== '' || this.state.emailAddress !== ''))}
                            fullWidth
                            inputProps={{maxLength: 14}}
                            defaultValue=" "
                            label="Provider Hub Provider Group ID"
                            margin="normal"
                            variant="outlined"
                            onChange={this.onChange}
                            value={this.state.providerHubGroupId}
                        />
                    </Grid>
                </Grid>
                
                <div style={{ marginTop: '20px', marginBottom: '20px' }}>
                    <ContentToggle
                        moreLabel="More Options"
                        lessLabel="Hide Options"
                        expanded={this.state.moreOptionsExpanded}
                        onExpand={() => this.handleMoreOptionsToggle(true)}
                        onCollapse={() => this.handleMoreOptionsToggle(false)}
                    >
                        <div style={{ marginTop: '10px', marginBottom: '10px' }}>
                            <TextField
                                id="outlined-basic"
                                name='username'
                                disabled={this.state.portalUserGroupId !== '' || this.state.taxIdNumber !== '' || 
                                          this.state.selectedRosterHubSource !== null || this.state.providerHubGroupId !== '' || 
                                          this.state.emailAddress !== ''}
                                style={{minWidth:'250px', marginRight: '20px'}}
                                inputProps={{maxLength: 50}}
                                defaultValue=" "
                                label="Username"
                                margin="normal"
                                variant="outlined"
                                onChange={this.onChange}
                                value={this.state.username}
                            />
                            
                            <div className="field-separator">OR</div>
                            
                            <TextField
                                id="outlined-basic"
                                name='emailAddress'
                                disabled={this.state.portalUserGroupId !== '' || this.state.taxIdNumber !== '' || 
                                          this.state.selectedRosterHubSource !== null || this.state.providerHubGroupId !== '' || 
                                          this.state.username !== ''}
                                style={{minWidth:'250px'}}
                                inputProps={{maxLength: 100}}
                                defaultValue=" "
                                label="Email Address/Domain"
                                margin="normal"
                                variant="outlined"
                                onChange={this.onChange}
                                value={this.state.emailAddress}
                            />
                        </div>
                    </ContentToggle>
                </div>
                
                <div className='Manage-tins-btn-ln'>
                    <Button onClick={this.handleSearch}>
                        SEARCH
                    </Button>
                    
                    <Button variant="outlined" onClick={this.handleReset}>
                        RESET
                    </Button>
                </div>
                
                {this.state.showResults && (
                    <div className="search-results">
                        <h2>Search Results</h2>
                        {this.state.groups.length > 0 ? (
                            <ManageGroupsTable 
                                groups={this.state.groups} 
                                setFilter={this.setFilter}
                                handleGroupAction={this.handleSelectedAction}
                            />
                        ) : (
                            <div className="no-results">
                                <p>No results found. Please try a different search.</p>
                            </div>
                        )}
                    </div>
                )}
                
                {this.state.searchPerformed && !this.state.showResults && !this.state.isLoading && !this.state.errorMsg && (
                    <div className="no-results">
                        <p>No search results to display. Please enter search criteria and click SEARCH.</p>
                    </div>
                )}
            </div>
        );
    }
}

export default withStyles(styles)(ManageGroups);
